import component from "containers/StaticPages/pages/EnergyStorage";

export default {
  key: "energy-storage",
  title: "Energy Storage",
  path: "/:user?/energy-storage",
  pageName: "energy-storage",
  linkTarget: "/energy-storage",
  component,
};
